var _rect, _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    fill: "#04132B"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.1728 194.266L22 128L31.8883 110.842L70.0611 177.108H146.407L146.273 177.333L136.518 194.266H60.1728Z",
    fill: "url(#paint0_linear_4_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.34 220H75.0017L65.1134 202.842H141.466L179.632 136.583L189.52 153.741L151.34 220Z",
    fill: "url(#paint1_linear_4_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.171 153.741L180.998 220.007H161.236L199.401 153.741L161.236 87.4748H180.998L219.171 153.741Z",
    fill: "url(#paint2_linear_4_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234 128L224.119 145.158L185.946 78.8991H109.6L119.482 61.7409H195.834L234 128Z",
    fill: "url(#paint3_linear_4_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.66 36H181.005L190.887 53.1583H114.541L76.3683 119.424L66.48 102.266L104.66 36Z",
    fill: "url(#paint4_linear_4_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5987 102.266L94.7714 168.525H75.0018L36.829 102.259L75.0018 36H94.7714L56.5987 102.266Z",
    fill: "url(#paint5_linear_4_2)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M106.733 152H97.5927L114.235 104.727H124.807L141.472 152H132.332L119.706 114.422H119.336L106.733 152ZM107.033 133.465H131.962V140.343H107.033V133.465ZM156.262 104.727V152H147.699V104.727H156.262Z",
    fill: "url(#paint6_linear_4_2)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4_2",
    x1: 94.9784,
    y1: -27.0765,
    x2: 73.5166,
    y2: 329.152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0087FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4_2",
    x1: 139.478,
    y1: -24.3916,
    x2: 118.019,
    y2: 331.828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0087FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4_2",
    x1: 198.694,
    y1: -20.8297,
    x2: 177.232,
    y2: 335.399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0087FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4_2",
    x1: 179.33,
    y1: -21.9934,
    x2: 157.868,
    y2: 334.236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0087FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4_2",
    x1: 134.834,
    y1: -24.6723,
    x2: 113.374,
    y2: 331.547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0087FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4_2",
    x1: 75.6211,
    y1: -28.2438,
    x2: 54.1594,
    y2: 327.985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0087FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4_2",
    x1: 128.5,
    y1: 89,
    x2: 128.5,
    y2: 168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01B2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 36,
    width: 212,
    height: 184,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.7cf6ad9035ba7230e53dc864aad7cb17.svg";
export { ForwardRef as ReactComponent };